/**
 * @license Copyright (c) 2012, RISE Ges.m.b.H.
 * Copyright (c) 2012, RISE Ges.m.b.H.
 *
 * Date: {{DATE}}
 *
 * @module  NotificationBar
 */

(function() {

    window.notification = {
        NotificationManager: NotificationManager,
        NotificationBar: NotificationBar
    };

/****** NotificationManager *******/

    /**
     * Manager class which handles NotificationBars. Only one NotificationBar per NotificationManager can be open at the same time.
     *
     * @class   NotificationManager
     * @constructor
     * @param   {Object}    options   Additional options for this instance. See NotificationBar docu.
     */
    function NotificationManager(options) {
        var self = this;

        this.settings = $.extend({
            position: "top", // [ top | bottom | left | right ]
            duration: 3000,
            styleClass: ""
        }, options);

        this.activeNotificationBars = [];
    }

    /**
     * Shows a Flag-styled information overlay.
     *
     * @method  showIndicator
     * @param   {Object}    options     additional options for a single NotificationBar
     */
    NotificationManager.prototype.showIndicator = function(options) {
        this.showNotification($.extend({}, this.settings, {
            autoClose: true,
            showMessage: false,
            showClose: false,
            duration: 10000,
            styleClass: "indicator"
        }, options));
    };

    /**
     * Shows an error message overlay
     *
     * @method  showErrorMessage
     * @param   {String|Box}    msg         message to show
     * @param   {Object}        options     additional options for a single NotificationBar
     */
    NotificationManager.prototype.showErrorMessage = function (msg, options) {

        this.showNotification($.extend({}, this.settings, {
            message: msg,
            icon: "error",
            autoClose: false
        }, options));
    };

    /**
     * Shows a warning message overlay
     *
     * @method  showWarningMessage
     * @param   {String|Box}    msg         message to show
     * @param   {Object}        options     additional options for a single NotificationBar
     */
    NotificationManager.prototype.showWarningMessage = function (msg, options) {

        this.showNotification($.extend({}, this.settings, {
            message: msg,
            icon: "warning",
            autoClose: true,
            duration: 5000
        }, options));
    };

    /**
     * Shows an info message overlay
     *
     * @method  showInfoMessage
     * @param   {String|Box}    msg         message to show
     * @param   {Object}        options     additional options for a single NotificationBar
     */
    NotificationManager.prototype.showInfoMessage = function (msg, options) {

        this.showNotification($.extend({}, this.settings, {
            message: msg,
            autoClose: true
        }, options));
    };

    /**
     * Shows a success message overlay
     *
     * @method  showSuccessMessage
     * @param   {String|Box}    msg         message to show
     * @param   {Object}        options     additional options for a single NotificationBar
     */
    NotificationManager.prototype.showSuccessMessage = function (msg, options) {

        this.showNotification($.extend({}, this.settings, {
            message: msg,
            icon: "success",
            autoClose: true
        }, options));
    };

    /**
     * Shows a default message overlay without special options set
     *
     * @method  showNotification
     * @param   {Object}        options     additional options for a single NotificationBar
     */
    NotificationManager.prototype.showNotification = function(options) {
        var self, notificationBar;

        options = $.extend({
            position: this.position,
            styleClass: this.styleClass
        }, options);

        self = this;
        notificationBar = new NotificationBar(options);

        self.closeAll();
        self.activeNotificationBars.push(notificationBar);
        notificationBar.show();
    };

    /**
     * Closes all NotificationBars for this NotificationManager instance
     *
     * @method  closeAll
     */
    NotificationManager.prototype.closeAll = function () {
        var self = this;

        $.each(self.activeNotificationBars, function (idx, notificationBar) {
            notificationBar.close(0);
        });

        self.activeNotificationBars = [];
    };

/****** NotificationBar ******/

    /**
     * NotificationBar implementation
     *
     * @class   NotificationBar
     * @constructor
     * @param   {Object}    options     additional options for this NotificationBar instance
     */
    function NotificationBar(options) {
        // inherits all settings from NotificationManager
        this.settings = $.extend({
            autoClose : false,          // flag to autoClose notification message
            icon: "info",               // styleclass for image error/success/info/warning/...
            message: '',                // message to display
            content: undefined,         // objects to be shown inside the notification bar passed as DOM Elements
            modal: false,               // whether the notification should be a modal dialog or not
            closeHandler: undefined,    // called when close button is pressed
            onClose: undefined,          // pressed when notification is closed
            showMessage: true,
            showIcon: true,
            showClose: true,
            body: $('body')
        }, options);

        this.notificationBar = undefined;
        this.modalDialog = undefined;
    }

    /**
     * Shows this NotificationBar instance
     *
     * @method  show
     */
    NotificationBar.prototype.show = function() {
        var self, css;

        self = this;

        if (this.notificationBar) {
            this.notificationBar.remove();
        }

        // Creates an Notification Bar at the top of the browser window. Due to the fixed positioning, it does
        // not move when the page is scrolled.
        this.notificationBar = self.settings.body.prependElement(
            Box ({ "class" : "notification "+ self.settings.position + " " + self.settings.icon + " " + self.settings.styleClass },
                FBox ({"class" : "container center clearfix"}, [
                    function(parent) {

                        if(self.settings.showIcon) {
                            parent.appendElement(
                                FBox({"class" : "container-icon " + self.settings.icon})
                            );
                        }

                        if(self.settings.showMessage) {
                            parent.appendElement(
                                FBox({"class" : "container-message"}, [
                                    FBox({"class" : "notification-header " + (self.settings.content ? "" : "one-line" )}, self.settings.message),
                                    FBox({}, function(parent) {
                                        parent.append(self.settings.content);
                                    })
                                ])
                            );
                        }

                        if(self.settings.showClose) {
                            parent.appendElement(
                                FBox({"class" : "container-close",
                                    click : function(e) {
                                        if(self.settings.closeHandler) {
                                            self.settings.closeHandler(e);
                                        }
                                        self.close(0);
                                    }
                                })
                            );
                        }

                    }
                ])
            )
        );

        if(this.settings.modal) {
            this.modalDialog = self.settings.body.prependElement(
                Box({ "class":"notification-modal" })
            );
            this.modalDialog.height(Math.max(window.outerHeight, self.settings.body.find("#container").height() + 100));
        }

        // set CSS top|bottom property to minus of div height, so it's not visible at the beginning
        css = {};
        css[this.settings.position] = '-' + self.notificationBar.height() + 'px';
        self.notificationBar.css(css);

        // showing notification message, default it will be hidden
        self.notificationBar.show();

        // show notification bar by sliding it down
        css[this.settings.position] = 0;

        this.notificationBar.animate(css, 'slow', undefined, function () {
            if (self.settings.autoClose) {
                self.close();
            }
        });
    };

    /**
     * Hides this NotificationBar instance
     *
     * @method  close
     */
    NotificationBar.prototype.close = function(timeout) {
        var self, deferred, css;

        self = this;
        // function is resolved, after the NB is completely hidden or NB is undefined
        deferred = new $.Deferred();

        if (this.notificationBar !== undefined) {

            css = {};
            css[self.settings.position] = '-' + this.notificationBar.height();

            setTimeout(function() {
                self.notificationBar.animate(css, undefined, undefined, function() {
                    if (self.modalDialog !== undefined) {
                        self.modalDialog.hide().remove();
                    }

                    if(self.settings.onClose) {
                        self.settings.onClose();
                        // TODO workaround because this code is called twice, investigate ...
                        self.settings.onClose = undefined;
                    }

                    self.notificationBar.remove();

                    return deferred.resolve();
                });
            }, timeout !== undefined ? timeout : self.settings.duration);
        } else {
            return deferred.resolve();
        }
        return deferred.promise();
    };
}());
/* @license end of code */